import { createSessionStorage, createStorage } from "./storage";

// Internal: exported only for tooling that needs to seed the same keys
// the auth provider reads on hydration. Application code should use
// `authStorage` below, not this constant.
export const AUTH_STORAGE_NAMESPACE = "medbillai-auth-state";
export const authStorage = createStorage({ namespace: AUTH_STORAGE_NAMESPACE });

// App download Web storage
export const downloadStorage = createStorage({
  namespace: "medbillai-downloads",
});

// User segmentation data storage
export const userSegmentationStorage = createSessionStorage({
  namespace: "medbillai-user-segmentation",
});

// Web to mobile modal storage
export const escalationModalStorage = createStorage({
  namespace: "medbillai-web-to-mobile-modal",
});

// Anonymous session storage - holds the signed JWT from the pre-auth flow
export const anonymousSessionStorage = createStorage({
  namespace: "medbillai-anonymous-session",
});

// This store is used to carry onboarding data across the auth boundary until
// the onboarding flow handles account creation itself. This is a temporary
// workaround until the auth architecture is refactored. No further data should
// be added until that refactoring is complete.
// @deprecated("DO NOT USE for new data until onboarding flow auth refactoring is complete OR YOU WILL BE FIRED.")
// See https://www.notion.so/medbill-ai/Onboarding-Login-integration-options-34cbbc89f6a28084958fc3f0c9a893e7
export const onboardingStorage = createStorage({
  namespace: "medbillai-onboarding",
});

// Add other storage instances as needed
// export const someOtherStorage = createStorage({ namespace:
// "some-other-namespace" });
